class OrderSheetForm extends HTMLElement {
  constructor() {
    super();
    this.submitButton = this.querySelector('[data-order-sheet-submit]');
    this.submitButtonText = this.querySelector('[data-order-sheet-submit-text]');
    this.messageElement = this.querySelector('[data-order-sheet-message]');
    this.spinner = this.querySelector('.loading__spinner');

    if (this.submitButton) {
      this.submitButton.addEventListener('click', this.onSubmit.bind(this));
    }
  }

  getItems() {
    const inputs = this.querySelectorAll('[data-order-sheet-qty]');
    const items = [];

    inputs.forEach((input) => {
      const quantity = parseInt(input.value, 10);
      if (quantity > 0) {
        items.push({
          id: parseInt(input.dataset.variantId, 10),
          quantity,
        });
      }
    });

    return items;
  }

  onSubmit(event) {
    event.preventDefault();
    this.setMessage();

    const items = this.getItems();

    if (items.length === 0) {
      this.setMessage('Enter a quantity for at least one product.', true);
      return;
    }

    this.toggleLoading(true);

    fetch(`${routes.cart_add_url}`, {
      ...fetchConfig('javascript'),
      body: JSON.stringify({ items }),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.description || response.errors) {
          this.setMessage(response.description || (window.cartStrings ? window.cartStrings.error : 'An error occurred.'), true);
          this.toggleLoading(false);
          return;
        }

        window.location.href = window.routes.cart_url;
      })
      .catch(() => {
        this.setMessage(window.cartStrings ? window.cartStrings.error : 'An error occurred.', true);
        this.toggleLoading(false);
      });
  }

  setMessage(message, isError) {
    if (!this.messageElement) return;

    if (!message) {
      this.messageElement.hidden = true;
      this.messageElement.textContent = '';
      this.messageElement.classList.remove('order-sheet__message--error');
      return;
    }

    this.messageElement.hidden = false;
    this.messageElement.textContent = message;
    this.messageElement.classList.toggle('order-sheet__message--error', Boolean(isError));
  }

  toggleLoading(loading) {
    this.submitButton.toggleAttribute('disabled', loading);
    if (this.spinner) this.spinner.classList.toggle('hidden', !loading);
    if (this.submitButtonText) this.submitButtonText.classList.toggle('hidden', loading);
  }
}

customElements.define('order-sheet-form', OrderSheetForm);
